module.exports = __webpack_public_path__ + "static/img/30647ccd.c10.c893173.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/rowdy-coyote/30647ccd.c10.jpg
// module id = f20s
// module chunks = 2